import type { Baseline } from '@/types';
import { api } from './api';

const baselineApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getBaseline: builder.query<Baseline[], number>({
      query: (id) => `inventories/${id}/baseline`,
    }),
  }),
});

export const { useGetBaselineQuery } = baselineApi;
